import httpServices from 'services/http.service';
import { API_URLS } from 'config/constants';

export interface CreateExpensePayload {
  amount: number;
  person?: string;
  description?: string;
}

export interface ExpenseListParams {
  dateFrom?: string;
  dateTo?: string;
  sort?: 'asc' | 'desc';
}

export const createExpense = (data: CreateExpensePayload) => (
  httpServices.post(API_URLS.EXPENSE.CREATE, data)
);

export const getExpenses = (params?: ExpenseListParams) => (
  httpServices.get(API_URLS.EXPENSE.LIST, { params })
);
